import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import modulesApi from "../api/module/modulesApi";
import paymentApi from "../api/paymentApi";
import paymentsMethod from "../consts/paymentsMethod";

// create slice
const name = "payment";
const initialState = createInitialState();
const extraActions = createExtraActions();
const extraReducers = createExtraReducers();
const slice = createSlice({ name, initialState, extraReducers });

// exports

export const paymentActions = { ...slice.actions, ...extraActions };
export const paymentReducer = slice.reducer;

// implementation

function createInitialState() {
  return {
    lstMethod: [],
    // isCreate: false,
  };
}

function createExtraActions() {
  return {
    getMethod: getMethod(),
  };

  function getMethod() {
    return createAsyncThunk(
      `${name}/getMethod`,
      async () => await modulesApi.getPaymentMethod()
    );
  }
}

function createExtraReducers() {
  return {
    ...getMethod(),
  };

  function getMethod() {
    const { pending, fulfilled, rejected } = extraActions.getMethod;
    return {
      [pending]: (state) => {
        state.lstMethod = paymentsMethod;
      },
      [fulfilled]: (state, action) => {
        let response = paymentsMethod;
        const data = action.payload.values;
        if (data) {
          const newArray = data.concat(...paymentsMethod);
          response = Array.from(new Set(newArray.map((a) => a.key))).map(
            (key) => {
              return newArray.find((a) => a.key === key);
            }
          );
          console.log("response", response);
        }
        state.lstMethod =
          data === null || data.length === 0 ? paymentsMethod : response;
        // state.isCreate = data === null || data.length === 0 ? false : true;
      },
      [rejected]: (state, action) => {
        state.lstMethod = paymentsMethod;
      },
    };
  }
}
